import { useTheme } from '@mui/styles'
import DataGridWithSearchV2 from 'components/generic/datagrid/DataGridWithSearchV2'
import { useMemo } from 'react'
import { Button } from '@mui/material_modern'
import { showFormModal } from 'state/ui/index'
import { useDispatch } from 'react-redux'
import { GS_ROLE_INFO } from 'utils/constants'

// Function to generate styles based on theme
const getGridStyles = theme => ({
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    padding: 0,
  },
  '& .MuiDataGrid-columnHeader': {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  '& .MuiDataGrid-cell': {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  '& .MuiDataGrid-columnSeparator': {
    visibility: 'hidden',
  },
  '& .MuiDataGrid-row': {
    '&.Mui-selected': {
      backgroundColor: 'inherit',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
      },
    },
    '&:not(.Mui-selected)': {
      backgroundColor: 'inherit',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
      },
    },
  },
  '& .MuiDataGrid-columnHeader:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
})

const UsersGrid = ({ apiRef, ...restProps }) => {
  const theme = useTheme()
  const dispatch = useDispatch()

  const columns = useMemo(
    () => [
      {
        field: 'name',
        headerName: 'User',
        flex: 1,
        renderCell: params => (
          <Button
            variant="text"
            onClick={() =>
              dispatch(
                showFormModal({ formModalName: 'add-edit-user-blade', formModalProps: { userId: params.row.id } }),
              )
            }
            style={{ textTransform: 'none' }}
          >
            {params.value}
          </Button>
        ),
      },
      {
        field: 'email',
        headerName: 'Email',
        flex: 1,
      },
      {
        field: 'greensparkRole',
        headerName: 'Role',
        flex: 1,
        renderCell: params => {
          return GS_ROLE_INFO[params.value]?.name || params.value
        },
      },
      {
        field: 'active',
        headerName: 'Status',
        flex: 1,
        renderCell: params => (params.value ? 'Active' : 'Inactive'),
        headerAlign: 'center',
        align: 'center',
      },
    ],
    [],
  )

  return (
    <>
      <DataGridWithSearchV2
        {...(restProps as any)} // Cast restProps to 'any'
        sx={getGridStyles(theme)}
        columns={columns}
        textSearchPlaceholder="Search Users"
        disableColumnMenu
        apiRef={apiRef}
        autoPageSize={false}
        sortingMode="server"
      />
    </>
  )
}

export default UsersGrid
